import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@/contexts/AuthContext.tsx';
import securitiesTransactionService from "@securitiesTransactionService";

export function useSecuritiesTransactionDetail(id: string) {
  const { user } = useAuth();

  return useQuery({
    queryKey: ['securities-transaction-detail', id, user?.id],
    queryFn: async () => {
      return await securitiesTransactionService.fetchSecurityTransaction({
        id,
        userId: user.id,
      });
    },
    staleTime: 86_400_000,
    gcTime: 86_400_000,
    enabled: !!user && !!id,
  });
}
